import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@criteria-labs/react';
export function EmptyView() {
    return (_jsx("div", { className: "flex h-full w-full items-center justify-center overflow-clip py-2", children: _jsx(Text, { children: "Click Send to get a response." }) }));
}
